import { useState, useEffect, useCallback } from "react";
import { getUrl } from "aws-amplify/storage";
import { Cache } from "aws-amplify/utils";
import { 
  UserCircleIcon
} from "@heroicons/react/24/outline";

export const UserAvatar = (props) => {
  // input
  const { url = null} = props;

  // state
  const [previewUrl, setPreviewUrl] = useState(null);

  const signedurl = useCallback(async () => {
    // find in cache
    const cache = await Cache.getItem(url);

    // chech
    if (cache) {
      const now = Math.floor(new Date().getTime() / 1000);
      const expired = Math.floor(new Date(cache.expired_at).getTime() / 1000);

      if (now < expired) {
        setPreviewUrl(cache.signed_url)
        return cache.signed_url;
      }
    }

    const signedUrl = await getUrl({
      path: url,
      options: {
        expiresIn: 3600,
      }
    });
    const signed_url = signedUrl.url.toString();
    console.log('signed_url', signed_url);

    // save in cache
    await Cache.setItem(url, {
      signed_url: signed_url,
      expired_at: new Date(new Date().getTime() + 3600 * 1000).toISOString(),
    });

    setPreviewUrl(signed_url)
    return signed_url;

  }, [url]);

  useEffect(() => {
    // sanity check
    if (!url) return;

    signedurl();
  }, [url])

  return (
    <>
      {!previewUrl &&
        <div className="h-[80px] w-[80px]">
          <UserCircleIcon color="#d1d1d1"/>
        </div>
      }
      {previewUrl &&
        <div className="w-[60%]">
          <img src={previewUrl} />
        </div>
      }
    </>
  )
}